export default __webpack_public_path__ + "aac2d9e90903ceee86e456df6969db48.gif";